import { createContext } from 'react';

export const CodeHighlightContext = createContext<{
  activeElement: string | null;
  activeLines: Array<number | string>;
  setActiveLines: (id: string) => void;
}>({ activeElement: null, activeLines: [], setActiveLines: () => null });
